import { EventSourcePolyfill } from "event-source-polyfill";

type JsonSerialized<T> = string & {
  __json_seralized: T;
};

export type StreamEvent =
  | {
      type: "start";
      user_conversation: {
        id: number;
        user: number;
        session: number;
        reply_to?: number | null;
        sender_type: "user";
        content?: string;
        company: number;
        created: string;
        metadata?: JsonSerialized<{
          company_id?: number;
          team_id?: number;
          start_date?: string;
          end_date?: string;
          time_frame?: string | "custom";
          report_type?:
            | "level_option_summary_report"
            | "individual_sales_report"
            | "monitoring_report";

          date_range?: string;
          total_reports?: number;
          reports?: any[];
        }>;
        user_name: string;
      };
      session_id: number;
      channel_id: string;
    }
  | { type: "chunk"; content?: string }
  | { type: "stopped"; channel_id?: string }
  | {
      type: "end";
      system_conversation: {
        id: number;
        user: number;
        session: number;
        reply_to?: number;
        sender_type: "system";
        content: string;
        company: number;
        created: string;
        metadata?: JsonSerialized<{
          company_id?: number;
          team_id?: number;
          start_date?: string;
          end_date?: string;
          time_frame?: string | "custom";
          report_type?:
            | "level_option_summary_report"
            | "individual_sales_report"
            | "monitoring_report";

          date_range?: string;
          total_reports?: number;
          reports?: any[];
        }>;
        user_name: string;
      };
      session_id: number;
      channel_id: string;
      daily_report_images?: {
        date: string;
        images?: string[];
      }[];
    }
  | { type: "error"; error: string };

export function useSSE(
  channelId: string | number,
  eventHandler: (eventSource: EventSource) => void,
) {
  const authStore = useAuthStore();
  const { token, apiAutoPromptVersion } = storeToRefs(authStore);

  const config = useRuntimeConfig();

  const sseUrl = `${config?.public?.API_BASE_URL}/api/sse${apiAutoPromptVersion.value}/channel/${channelId}/`;

  const eventSource = ref<EventSourcePolyfill>();

  const connect = () => {
    if (eventSource.value) return;

    eventSource.value = new EventSourcePolyfill(sseUrl, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${token.value?.access}`,
      },
    });
    eventSource.value.onopen = () => {
      console.info("SSE connection opened");
    };

    eventSource.value.onerror = (error: any) => {
      console.error("SSE connection error", error);
    };

    // eventSource.value.onmessage = (event: any) => {
    //   console.info("SSE message received", event.data);
    // };

    eventHandler(eventSource.value);
  };

  connect();

  const disconnect = () => {
    if (eventSource.value) {
      eventSource.value.close();
      eventSource.value = undefined;
      console.info("SSE connection closed");
    }
  };

  return {
    eventSource,
    disconnect,
  };
}
